module.exports = __webpack_public_path__ + "static/img/integral.3abb1c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integral.png
// module id = MM3+
// module chunks = 1